const products = [
  {
    id: "vpn",
    name: "MAHHERC VPN",
    tagline: "Secure. Private. Unrestricted.",
    description:
      "Military-grade encryption that shields your digital life. Browse freely, protect sensitive data, and stay anonymous on any network.",
    image:
      "https://public.readdy.ai/ai/img_res/e591200c497eeac7b447af12f3a8c174.jpg",
    icon: "ri-shield-keyhole-line",
    accent: "text-green-400",
    border: "border-green-400/20",
    features: ["AES-256 Encryption", "Zero-Log Policy", "40+ Server Locations"],
  },
  {
    id: "cleaner",
    name: "MAHHERC Cleaner",
    tagline: "Optimized. Fast. Free.",
    description:
      "Reclaim storage, boost performance, and keep your iPhone running at peak efficiency with intelligent, automated cleaning.",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20phone%20cleaner%20optimization%20app%20concept%20with%20glowing%20cyan%20sparkle%20icon%20on%20very%20dark%20background%20deep%20charcoal%20gradient%20to%20black%20with%20subtle%20particle%20dust%20effects%20minimalist%20iOS%20app%20art&width=600&height=800&seq=cleaner1&orientation=portrait",
    icon: "ri-star-line",
    accent: "text-cyan-400",
    border: "border-cyan-400/20",
    features: ["Smart Junk Removal", "Duplicate Photo Finder", "Memory Booster"],
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-24 md:py-36 bg-[#f8f8f6]">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16 md:mb-20">
          <span className="text-xs uppercase tracking-[0.3em] text-gray-400 font-medium mb-4 block">
            / Our Products /
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-gray-900 leading-tight tracking-tight">
            iOS Applications
            <br />
            <span className="text-gray-300">Built to Perform</span>
          </h2>
          <p className="mt-6 text-gray-500 text-base md:text-lg max-w-xl leading-relaxed">
            Each product in the MAHHERC suite is purpose-built for iOS — native,
            fast, and crafted with an obsessive attention to user experience.
          </p>
        </div>

        {/* Product cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {products.map((p) => (
            <div
              key={p.id}
              className={`relative rounded-3xl overflow-hidden border ${p.border} bg-[#111] group`}
              style={{ minHeight: "520px" }}
            >
              {/* Background image */}
              <div className="absolute inset-0">
                <img
                  src={p.image}
                  alt={p.name}
                  className="w-full h-full object-cover object-top opacity-60 group-hover:opacity-80 transition-opacity duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/10" />
              </div>

              {/* Content */}
              <div className="relative z-10 p-8 md:p-10 flex flex-col justify-between h-full min-h-[520px]">
                {/* Top badge */}
                <div
                  className={`inline-flex items-center gap-2 self-start border ${p.border} rounded-full px-4 py-2`}
                >
                  <i className={`${p.icon} ${p.accent} text-base w-4 h-4 flex items-center justify-center`} />
                  <span className={`text-xs uppercase tracking-widest font-medium ${p.accent}`}>
                    iOS App
                  </span>
                </div>

                {/* Bottom info */}
                <div>
                  <p className={`text-xs uppercase tracking-widest font-medium mb-2 ${p.accent}`}>
                    {p.tagline}
                  </p>
                  <h3 className="text-2xl md:text-3xl font-bold text-white mb-3 tracking-tight">
                    {p.name}
                  </h3>
                  <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-sm">
                    {p.description}
                  </p>
                  <div className="flex flex-wrap gap-2">
                    {p.features.map((f) => (
                      <span
                        key={f}
                        className="text-xs text-white/60 border border-white/10 rounded-full px-3 py-1 whitespace-nowrap"
                      >
                        {f}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
